import { ApiResult } from '@synergy/api';
import { request, safeRequest } from '@synergy/api';

import { SearchResult } from './model/search-result';

export class DashboardApi {
    constructor(protected baseUrl: string) {}

    public cget(params?: URLSearchParams): Promise<ApiResult<SearchResult>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/dashboard`, { params }),
            response => SearchResult.fromPlainObject(response.data)
        );
    }
}
